function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { WhiteboardTool } from './WhiteboardTool';
import { TextEditor } from '../edit/TextEditor';
export class TextTool extends WhiteboardTool {
  constructor(enableToolEvent, model, shadowEmitter, scope, rootView, canvasElement, toolbarModel, camera) {
    super(enableToolEvent, model, shadowEmitter, scope);
    _defineProperty(this, "from", null);
    _defineProperty(this, "to", null);
    _defineProperty(this, "rootView", void 0);
    _defineProperty(this, "canvasElement", void 0);
    _defineProperty(this, "elementModel", null);
    _defineProperty(this, "toolbarModel", void 0);
    _defineProperty(this, "camera", void 0);
    _defineProperty(this, "showLiveCursor", false);
    this.rootView = rootView;
    this.canvasElement = canvasElement;
    this.toolbarModel = toolbarModel;
    this.camera = camera;
  }
  onMouseDown(event) {
    this.from = event.point.clone();
  }
  onMouseDrag(_event) {}
  onMouseUp(event) {
    this.to = event.point.clone();
    if (!this.from || !this.to) {
      return;
    }
    if (this.from.getDistance(this.to) < 100) {
      this.createPointEditor(event.point.x, event.point.y);
    }
  }
  createPointEditor(x, y) {
    if (this.elementModel) {
      this.elementModel.dispose();
    }
    this.elementModel = null;
    this.modelGetter().then(model => {
      if (model) {
        this.elementModel = model.createPointText(x, y, true);
        if (this.elementModel === null) {
          return;
        }
        const editorContainer = window.document.createElement('div');
        const canvasBounds = this.canvasElement.getBoundingClientRect();
        editorContainer.style.cssText = `position:absolute;transform:translate(-50%, -50%);top:50%;left:50%;width:${canvasBounds.width}px;height:${canvasBounds.height}px;`;
        const editor = new TextEditor(this.camera);
        editor.setOrigin(x, y);
        editorContainer.appendChild(editor.rootView);
        this.rootView.appendChild(editorContainer);
        editor.setFontSize(this.toolbarModel.fontSize);
        editor.setFontFamily(this.toolbarModel.fontFamily);
        this.camera.triggerZoom();
        editor.on('caretOutRight', () => {
          // console.log('caretOutRight');
        });
        editor.on('change', content => {
          if (this.elementModel) {
            this.elementModel.content = content;
          }
        });
        editor.on('done', () => {
          if (this.elementModel) {
            if (!this.elementModel.content || this.elementModel.content.length === 0) {
              model.removeElementItem(this.elementModel.uuid);
            } else {
              this.elementModel.shadow = '';
            }
          }
          editor.dispose();
          this.rootView.removeChild(editorContainer);
        });
        setTimeout(() => {
          editor.focus();
        }, 30);
      }
    });
  }
}